export const BRAND = {
  name: "ECU SOLUTIONS",
  domain: "ecu-solutions.de",
  email: "info@ecu-solutions.de",
  whatsapp: "4915158473920",
  whatsappDisplay: "+49 1515 8473920",
  dev: { name: "DR-CODING", url: "https://dr-coding.de" },
};

const konfiguratorParams = new URLSearchParams({
  lic: "tgkjddiofjsiojfs646",
  origin: "dr-file.de", // Vom Anbieter vorgegebener Lizenzparameter.
  design: "v2",
  theme: "custom",
  lang: "de",
  bg: "#05070A",
  text: "#ffffff",
  accent: "#0055FF",
  pulse: "#0055FF",
  pulseOff: "0",
  dyno: "1",
  dynoBg: "#05070A",
  dynoText: "#ffffff",
  dynoAccent: "#0055FF",
});

// DR-DATA Fahrzeug-Konfigurator (Live)
export const KONFIGURATOR_URL = `https://konf.dr-file.de/index.php?${konfiguratorParams}`;

export const NAV_LINKS = [
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Konfigurator", href: "#konfigurator" },
  { label: "Services", href: "#services" },
  { label: "Entwicklung", href: "#softwareentwicklung" },
  { label: "Galerie", href: "#galerie" },
  { label: "FAQ", href: "#faq" },
];

export const STATS = [
  { value: "10", label: "Jahre Erfahrung" },
  { value: "1.000+", label: "Fahrzeuge optimiert" },
  { value: "GPS Dyno", label: "Leistungsmessung" },
  { value: "Werkstatt", label: "Partner & Support" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Direkt am Fahrzeug – kein Umweg",
    text: "Auslesen, optimieren, aufspielen und prüfen – alles direkt am Fahrzeug. Du bekommst das komplette Tuning aus einer Hand: verständlich erklärt, sauber umgesetzt und alltagstauglich abgestimmt.",
  },
  {
    no: "02",
    title: "Starker Partner für Werkstätten",
    text: "Werkstätten, Tuner und Autohäuser unterstützen wir mit schnellen, zuverlässigen Lösungen und persönlichem Support. Faire Konditionen, kurze Reaktionszeiten und eine Zusammenarbeit auf Augenhöhe.",
  },
];

export const SERVICES = [
  {
    title: "Software & Kennfeldoptimierung",
    tag: "Privat & Werkstatt · Stage 1–2+",
    desc: "Wir optimieren dein Fahrzeug direkt: mehr Leistung, mehr Drehmoment und ein besseres Ansprechverhalten – individuell abgestimmt und alltagstauglich.",
    img: "/ecupic/8.jpeg",
    alt: "Laptop zur Softwarearbeit im Cockpit eines Porsche",
    position: "50% 58%",
    span: "md:col-span-7",
  },
  {
    title: "AGR / DPF / SCR Solutions",
    tag: "Diagnose & Abgassysteme",
    desc: "Professionelle Lösungen rund um Abgasrückführung, Partikelfilter und AdBlue-Systeme – sauber am Fahrzeug umgesetzt.",
    img: "/ecupic/4.jpeg",
    alt: "Angeschlossene Programmierhardware und Laptop am offenen Motorraum",
    position: "50% 42%",
    span: "md:col-span-5",
  },
  {
    title: "Klonen von Steuergeräten",
    tag: "Steuergeräte & Datenübertragung",
    desc: "Sicheres Klonen und Wiederherstellen von Steuergeräten – ideal bei Defekt, Ersatz oder als Service für Werkstätten.",
    img: "/ecupic/9.jpeg",
    alt: "Geöffnetes Steuergerät mit Kontaktsonden und angeschlossenem Programmiergerät",
    position: "50% 52%",
    span: "md:col-span-5",
  },
  {
    title: "Öldruck Fix",
    tag: "Diagnose & Softwareanpassung",
    desc: "Softwareanpassung für geeignete Steuergeräte und Softwarestände. Wir prüfen vorab, ob die Lösung für dein Fahrzeug infrage kommt.",
    img: "/ecupic/6.jpeg",
    alt: "BMW-Innenraum mit Laptop und angeschlossenem Programmiergerät",
    position: "50% 60%",
    span: "md:col-span-7",
  },
];

export const SERVICE_OPTIONS = [
  "Software & Kennfeldoptimierung",
  "AGR / DPF / SCR Solutions",
  "Klonen von Steuergeräten",
  "Öldruck Fix",
  "Beratung / Sonstiges",
];

export const RESULTS = [
  { model: "VW Golf 7 GTI", engine: "2.0 TSI", stockPs: 245, tunedPs: 310, stockNm: 370, tunedNm: 440 },
  { model: "BMW 335i", engine: "3.0 N55", stockPs: 306, tunedPs: 390, stockNm: 400, tunedNm: 540 },
  { model: "Audi A4 B9", engine: "2.0 TDI", stockPs: 190, tunedPs: 240, stockNm: 400, tunedNm: 480 },
];

// The existing build reads the directory; absent files never become broken image requests.
const localImageFiles = new Set(JSON.parse(process.env.REACT_APP_ECU_IMAGE_FILES || "[]"));
export const hasLocalImage = (src) => localImageFiles.has(src.replace("/ecupic/", ""));

export const GALLERY = [
  { src: "/ecupic/3.jpeg", alt: "ECU-SOLUTIONS-Laptop in einer Traktorkabine", label: "Technik im Einsatz", tall: true },
  { src: "/ecupic/2.jpeg", alt: "Laptop und Programmiergerät im Volkswagen-Innenraum", label: "Direkt am Fahrzeug", position: "50% 35%" },
  { src: "/ecupic/8.jpeg", alt: "Softwarearbeit im Porsche-Cockpit", label: "Performance & Software", position: "50% 45%" },
  { src: "/ecupic/9.jpeg", alt: "Kontaktsonden auf einer geöffneten Steuergeräteplatine", label: "Bis ins Detail", position: "50% 48%" },
  { src: "/ecupic/1.jpeg", alt: "Diagnoselaptop in der Kabine eines Massey-Ferguson-Traktors", label: "Diagnose in der Praxis", tall: true },
  { src: "/ecupic/4.jpeg", alt: "Programmierhardware am offenen Motorraum in der Werkstatt", label: "Werkstattalltag", position: "50% 35%" },
  { src: "/ecupic/5.jpeg", alt: "Software auslesen mit Laptop und Interface im BMW", label: "Auslesen & abstimmen", position: "50% 58%" },
  { src: "/ecupic/6.jpeg", alt: "BMW mit angeschlossenem Laptop zur Steuergerätearbeit", label: "Fahrzeug & Kalibrierung", position: "50% 55%" },
].filter(({ src }) => hasLocalImage(src));

export const HERO_IMG = "/ecupic/7.jpeg";

export const SOFTWARE_IMAGES = [
  { src: "/ecupic/ols3.png", title: "Kennfelder im Zusammenhang", label: "01 / 3D-Analyse", alt: "WinOLS: dreidimensionale Kennfeldansicht über Drehzahl und Betriebsbereich", width: 1115, height: 534 },
  { src: "/ecupic/ols4.png", title: "Parameter aufeinander abstimmen", label: "02 / Kalibrierung", alt: "WinOLS: Tabellen für Füllung, Lambda und Motordrehmoment", width: 1758, height: 717 },
  { src: "/ecupic/ols2.png", title: "Verläufe nachvollziehen", label: "03 / Kennfeldverlauf", alt: "WinOLS: farbige 3D-Fläche mit Drehzahl- und Drehmomentachse", width: 1420, height: 372 },
  { src: "/ecupic/ols1.png", title: "Werte im Detail prüfen", label: "04 / Tabellenansicht", alt: "WinOLS: Kennfeldtabelle mit farbig markierten Werten", width: 1586, height: 376 },
].filter(({ src }) => hasLocalImage(src));

export const DYNO_IMAGES = [
  { src: "/ecupic/dyno1.png", title: "GPS-Dyno Messung", label: "01 / Messprotokoll", alt: "ECU-SOLUTIONS-Messprotokoll mit Leistungs- und Drehmomentkurve", width: 735, height: 517 },
  { src: "/ecupic/dyno2.png", title: "Leistungsanalyse", label: "02 / Messprotokoll", alt: "Dyno-Messprotokoll von ECU SOLUTIONS" },
  { src: "/ecupic/dyno3.png", title: "Leistungsmessung", label: "03 / Messprotokoll", alt: "Weiteres Dyno-Messprotokoll von ECU SOLUTIONS" },
].filter(({ src }) => hasLocalImage(src));

export const FAQ = [
  { q: "Wie läuft die Optimierung ab?", a: "Auslesen, optimieren, aufspielen und prüfen – alles direkt am Fahrzeug. Vereinbare am besten vorab einen Termin über das Kontaktformular oder per WhatsApp, dann klären wir die Details." },
  { q: "Arbeitet ihr auch mit Werkstätten zusammen?", a: "Absolut. Werkstätten, Tuner und Autohäuser unterstützen wir mit schnellen, zuverlässigen Lösungen, fairen Konditionen und persönlichem Support. Melde dich einfach – wir richten dir eine unkomplizierte Zusammenarbeit ein." },
  { q: "Ist das Tuning alltagstauglich?", a: "Ja. Wir legen größten Wert auf Zuverlässigkeit. Alle Optimierungen berücksichtigen die Belastungsgrenzen von Motor, Getriebe und Antriebsstrang." },
  { q: "Wie messt ihr die Leistung?", a: "Zur Verifikation nutzen wir unter anderem einen Straßen-GPS-Dyno, der Leistung und Beschleunigung unter realen Bedingungen erfasst. So bekommst du eine nachvollziehbare Einschätzung der Ergebnisse." },
  { q: "Welche Fahrzeuge und Steuergeräte werden unterstützt?", a: "Wir unterstützen ein sehr breites Spektrum an Marken, Modellen und Steuergerätetypen. Nutze den Konfigurator oder frag einfach an – wir prüfen dein Fahrzeug kostenlos." },
  { q: "Wer steckt technisch hinter ECU SOLUTIONS?", a: "ECU SOLUTIONS verbindet praktische Arbeit am Fahrzeug mit eigener Softwareentwicklung. Unsere Entwicklungsarbeit bei DR-CODING (dr-coding.de) ergänzt die Kennfeldanalyse und individuelle Kalibrierung von Steuergeräten." },
  { q: "Bekomme ich eine Beratung vorab?", a: "Selbstverständlich. Wir beraten dich ehrlich, was für dein Fahrzeug und deinen Einsatzzweck sinnvoll ist – ganz ohne Verkaufsdruck." },
];
